import "prismjs/themes/prism-tomorrow.css";
import { BRAND_NAME } from '../theme/brand';
import Prism from 'prismjs';
import React, { useEffect, useState } from 'react';
import Header from '../components/Header'
import { getUserFromToken } from '../components/authHelper';
import {
  Box,
  HStack,
  Text,
  Table,
  Thead,
  Tbody,
  Badge,
  Tr,
  Th,
  Td,
  TableContainer,
  Link,
  Card,
  Flex,
  Divider,
  Tag,
  VStack,
  Tabs,
  Tab,
  TabList,
  TabPanels,
  TabPanel,
  Center,
  Spinner
} from '@chakra-ui/react';
import "prismjs/components/prism-json"; // Ensure JSON support is loaded
import { fetchWrapper } from '../helpers';
import Select from "react-select";
import SMSOnlyAPIPanel from "./SMSOnlyAPI";
import usePagePermissions from '../hooks/usePagePermissions';
import BoxWrapper from "../components/BoxWrapper/BoxWrapper";

function User({ header }) {
  const [apiKey, setApiKey] = useState('')

  const [variableList, setVariableList] = useState([])
  const [data, setData] = useState({ "to": "[Number Goes Here]", "message": "[Message Goes Here]" })

  const [selectedTemplateMessage, setSelectedTemplateMessage] = useState('');
  const [payloadFields, setPayloadFields] = useState([
    {
      field: 'to',
      type: 'String',
      required: true,
      description: [
        'The recipient\'s phone number.',
        'Important: The number must be provided without a + sign.'
      ],
      isTemplateVariable: false
    },
    {
      field: 'email',
      type: 'string',
      required: false,
      description: "Email Address",
      isTemplateVariable: false
    },
    {
      field: 'message_template_id',
      type: 'Number',
      required: true,
      description: "Transaction Type is the Template ID which will be used. Each Template has its own set of Variables. ",
      isTemplateVariable: false
    },
    {
      field: 'preferred_channel',
      type: 'Number',
      required: true,
      description: "Preferred Channels is used when you want to override the Smart Routing or Custom Routing. Message will be sent to defined channel. If you want the smart routing or custom routing leave it blank.",
      isTemplateVariable: false
    },
  ]);
  const [templateOptions, setTemplateOptions] = useState([]);
  const responsedata = {
    "statusCode": 200,
    "status": "accepted",
    "messageid": "5e8c48b3-540a-4f43-ac8a-cc2a6a2114d6",
    "accepttime": 1727247788
  }


  const user = getUserFromToken();
  const id = user.customer_id;

  const { loading, can } = usePagePermissions('documentation/api-doc');

  const viewPermission = can("api-doc")
  useEffect(() => {
    if (loading || !viewPermission) return;
    Prism.highlightAll();
    loadList()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, viewPermission, id]);

  const loadList = async () => {

    const url = `${process.env.REACT_APP_API_URL}/customer/get-key?key_type=api_key`;
    const data = await fetchWrapper.get(url)

    setApiKey(data?.key || '')

  }


  const TemplateList = async () => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/template/msg-temp-type-ids`;
      const data = await fetchWrapper.get(url);

      let transformedData = data.data.map((item) => ({
        label: item?.name,
        value: item?.name,
        message: item?.message,
        ...item
      }));
      setTemplateOptions(transformedData);
    } catch (error) {
      console.error('Error fetching templates:', error);

    }
  };


  useEffect(() => {
    if (loading || !viewPermission) return;
    const initializeData = async () => {
      await loadVariableList(); // First load variables
      await TemplateList();    // Then load templates and auto-select first one
    };

    initializeData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, viewPermission]);



  useEffect(() => {
    if (templateOptions.length > 0) {
      const firstTemplate = templateOptions[0];
      handleSelectChange('template', firstTemplate);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [templateOptions]);




  const handleSelectChange = (field, option) => {
    const selectedTemplate = templateOptions.find(t => t.value === option.value);
    const variables = extractVariablesFromMessage(selectedTemplate.message);


    // Using map instead of forEach to create new array with combined data
    const updatedVariables = variables.map(variable => {
      const newvar = variableList?.find(
        v => v.variable === `$${variable.key}`
      );

      return {
        ...variable,
        ...newvar,
        value: variable.value // keep original value
      };
    });


    // Create a variablesObject that contains all template variables
    // This object maps each variable key to its type and will be used in the API payload
    const variablesObject = updatedVariables.reduce((acc, variable) => {
      acc[variable.key] = variable.type || "string";
      return acc;
    }, {});

    // IVR variables — spread directly into the payload (no nested "variables" object),
    // deduped by key so paths sharing the same last segment only show once
    const ivrVariables = extractIvrVariables(selectedTemplate.message_combine);
    const ivrVariablesObject = ivrVariables.reduce((acc, variable) => {
      acc[variable.key] = "string";
      return acc;
    }, {});

    // Create base data object with standard fields
    const baseData = {
      "to": "string",
      // "trans_type":selectedTemplate?.MessageTemplateType?.message_type_id,
      "email": "string (Optional)",
      "message_template_id": option?.id,
      "preferred_channel": "SMS/Whatsapp",

    };

    // Set data state with the combined object
    setData({ ...baseData, ...variablesObject, ...ivrVariablesObject });

    const newPayloadFields = [
      {
        field: 'to',
        type: 'String',
        required: true,
        description: 'The recipient\'s phone number.Important: The number must be provided without a + sign.',
        isTemplateVariable: false
      },
      {
        field: 'email',
        type: 'string',
        required: false,
        description: "The recipient’s Email Address. Send this in payload if you like to send email to the customer.",
        isTemplateVariable: false
      },
      {
        field: 'message_template_id',
        type: 'Number',
        required: true,
        description: "Transaction Type is the Template ID which will be used. Each Template has its own set of Variables. ",
        isTemplateVariable: false
      },
      {
        field: 'preferred_channel',
        type: 'string',
        required: true,
        description: "Preferred Channels is used when you want to override the Smart Routing or Custom Routing. Message will be sent to defined channel. If you want the smart routing or custom routing leave it blank.",
        isTemplateVariable: false
      },
      // Add template variables to payload fields
      ...updatedVariables.map(v => ({
        field: v.key,
        description: v.description,
        required: v.required || true,
        type: v.type || "string",
        isTemplateVariable: true
      })),
      // Add IVR variables to payload fields
      ...ivrVariables.map(v => ({
        field: v.key,
        description: `IVR variable used in the Voice (IVR) template.`,
        required: true,
        type: "string",
        isTemplateVariable: true
      }))
    ];

    setPayloadFields(newPayloadFields);
    // setData({...data , })



  };


  const loadVariableList = async () => {

    const url = `${process.env.REACT_APP_API_URL}/variables/list`;
    const data = await fetchWrapper.get(url);
    setVariableList(data.data);

  };
  const extractVariablesFromMessage = (message) => {
    const regex = /\$([a-zA-Z_][a-zA-Z0-9_]*)/g;
    const matches = message.match(regex) || [];
    return matches.map(match => ({
      key: match.substring(1), // Remove the $ prefix
      value: `${match.substring(1)} goes here`
    }));
  };

  const extractIvrVariables = (messageCombine) => {
    try {
      const parsed = typeof messageCombine === 'string' ? JSON.parse(messageCombine) : messageCombine;
      if (Array.isArray(parsed?.ivr_variables) && parsed.ivr_variables.length > 0) {
        const seen = new Set();
        const result = [];
        for (const path of parsed.ivr_variables) {
          const parts = path.split('.');
          const key = parts.length > 1 ? parts[parts.length - 1] : path;
          if (seen.has(key)) continue;
          seen.add(key);
          result.push({ key, value: '' });
        }
        return result;
      }
    } catch (e) {
      console.error('Failed to parse ivr_variables', e);
    }
    return [];
  };
  // Format data for display with template field comment
  const getFormattedJson = () => {
    const jsonObj = { ...data };

    // Create a formatted JSON string
    let jsonString = JSON.stringify(jsonObj, null, 2);

    // Find position to insert preferred_channel comment
    const lines = jsonString.split('\n');
    const preferredChannelIndex = lines.findIndex(line => line.includes('"preferred_channel"'));

    if (preferredChannelIndex !== -1) {
      // Get the indentation level
      const indentation = lines[preferredChannelIndex].match(/^\s*/)[0];

      // Modify the preferred_channel line to include the comment
      const originalLine = lines[preferredChannelIndex];
      const lineWithoutComma = originalLine.endsWith(',')
        ? originalLine.substring(0, originalLine.length - 1)
        : originalLine;

      lines[preferredChannelIndex] = `${lineWithoutComma}, // (Remove this key when using smart/custom routing) ${originalLine.endsWith(',') ? ',' : ''}`;

      // Add Template Fields comment after preferred_channel
      if (preferredChannelIndex < lines.length - 2) {
        lines.splice(preferredChannelIndex + 1, 0, `${indentation} //Template Fields.`);
      }

      jsonString = lines.join('\n');
    }

    return jsonString;
  };

  useEffect(() => {
    Prism.highlightAll();
  }, [data]); // Add data as dependency

  const Preferred_Channel = [

    {
      channel: 'SMS',
      value: 'SMS',
      description: 'SMS will be sent, overriding Custom Routing & Smart Routing'
    },
    {
      channel: 'WhatsApp',
      value: 'Whatsapp',
      description: 'WhatsApp will be sent, overriding Custom Routing & Smart Routing'
    },
    {
      channel: 'Mobile Push',
      value: 'Push Notification',
      description: 'Mobile Push Notification will be sent, overriding Custom Routing & Smart Routing'
    },
    {
      channel: 'Mobile Inbox',
      value: 'In-App Notification',
      description: 'Mobile Inbox message will be sent, overriding Custom Routing & Smart Routing. The Inbox channel is sent as "In-App Notification".'
    },
    {
      channel: 'Voice (IVR)',
      value: 'Voice (IVR)',
      description: 'Voice (IVR) will be sent, overriding Custom Routing & Smart Routing'
    },
    {
      channel: 'E-Mail',
      value: 'E-Mail',
      description: 'E-Mail will be sent, overriding Custom Routing & Smart Routing'
    },

  ];

  const headers = [
    {
      header: "x-api-key",
      value: apiKey || "your_api_key_here",
      description: "Your unique API authentication key",
      isApiKey: true
    },
    {
      header: "Content-Type",
      value: "application/json",
      description: "Request body format"
    }
  ];


  const defaultNotes = [
    "The phone number must be provided in international format without the + sign. For example, 447562914341 for a UK number.",
    "Message must contain an OTP Code"
  ];
  const responseCodes = [
    {
      code: "200",
      status: "Success",
      description: "Message sent successfully",
      color: "green"
    },
    {
      code: "400",
      status: "Bad Request",
      description: "Invalid request payload or missing required fields (Variable Missing,Template Id Missing,Invalid Channel)",
      color: "red"
    },
    {
      code: "401",
      status: "Unauthorized",
      description: "Invalid or missing API key",
      color: "red"
    },
    {
      code: "403",
      status: "Forbidden",
      description: "Insufficient permissions or account suspended",
      color: "red"
    },
    {
      code: "404",
      status: "Not Found",
      description: "Template or customer ID not found (Phone Number Missing,Country Not Allowed,Account Inactive,Duplicate Message,Invalid Template,Auth Failed)",
      color: "red"
    },
    {
      code: "429",
      status: "Rate Limit",
      description: "Too many requests - rate limit exceeded",
      color: "orange"
    },
    {
      code: "500",
      status: "Server Error",
      description: "Internal server error - please retry",
      color: "red"
    },
    {
      code: "503",
      status: "Service Unavailable",
      description: "Service temporarily unavailable - maintenance or high load",
      color: "orange"
    }
  ];


  if (loading) {
    return (
      <>
        <Header header={header} />
        <BoxWrapper>
          <Center h="400px">
            <Spinner size="xl" color="blue.500" thickness="4px" />
          </Center>
        </BoxWrapper>
      </>
    );
  }
  return (
    <>
      <Header header={header} />
      <BoxWrapper>
        {viewPermission ? <VStack align="stretch" spacing={8}>
          <Flex justify={"center"} align={"center"}>
            <Box w={"70%"} mt={8}>
              <Text fontSize={"4xl"} fontWeight={"semibold"}>Send Message API
              </Text>
              <Text color="gray.600" fontSize="md" mb={4}>
                The Send Message API allows you to deliver messages across SMS, WhatsApp, Push, Inbox, Voice, and Email through a single unified endpoint. {BRAND_NAME} automatically selects the most optimal channel based on routing rules, cost, and delivery availability.


              </Text>

            </Box>
          </Flex>
          <Divider bg={"#eaeaea"} />


          <Flex justify={"center"} align={"center"}>
            <Box style={{ width: '70%' }}>


              <Tabs variant="enclosed">
                <TabList
                  bg="#f1f5f9"
                  p="1"
                  borderRadius="full"
                  display="flex"
                  justifyContent="space-between"
                  w={"40%"}
                >
                  <Tab flex="1" _selected={{ bg: "white", boxShadow: "sm", fontWeight: "600" }} borderRadius="full" fontSize="sm" >All Channel API</Tab>
                  <Tab flex="1" _selected={{ bg: "white", boxShadow: "sm", fontWeight: "600" }} borderRadius="full" fontSize="sm" >Passthrough API</Tab>
                </TabList>

                <TabPanels>
                  {/* Android Tab */}
                  <TabPanel>
                    <Box my="20px" >
                      <HStack >
                        <Box>
                          <Tag borderRadius="md" fontSize="12px" fontWeight="600" bg="#ff6900" color="white" my="0px" >Post</Tag>
                        </Box>
                        <Tag bg={"#fefce8"} color={"#a65f00"} border={"1px solid #fff085"}>
                          <Link color="#a65f00" fontSize="16px" fontWeight="400" my="0px" href="#">{process.env.REACT_APP_SEND_API_URL}/v2/send</Link>
                        </Tag>
                      </HStack>
                    </Box>
                    <Text
                      fontSize="20px"
                      fontWeight="600"
                      color="#000000"
                      my="0px"

                    >
                      Headers
                    </Text>
                    <TableContainer
                      width="100%"
                      bg="white"
                      borderRadius="lg"
                      border="1px solid"
                      borderColor="gray.200"
                      overflow="hidden"
                    >
                      <Table variant="simple" width="100%">
                        <Thead bg="#f7f7f7">
                          <Tr>
                            <Th
                              fontSize="14px"
                              fontWeight="600"
                              color="black"
                              textTransform="none"
                              letterSpacing="normal"
                              py={4}
                            >
                              Header
                            </Th>
                            <Th
                              fontSize="14px"
                              fontWeight="600"
                              color="black"
                              textTransform="none"
                              letterSpacing="normal"
                              py={4}
                            >
                              Value
                            </Th>
                            <Th
                              fontSize="14px"
                              fontWeight="600"
                              color="black"
                              textTransform="none"
                              letterSpacing="normal"
                              py={4}
                            >
                              Description
                            </Th>
                          </Tr>
                        </Thead>

                        <Tbody fontSize="14px">
                          {headers.map((item, index) => (
                            <Tr
                              key={index}
                              _hover={{ bg: "gray.50" }}
                              transition="background 0.2s"
                            >
                              <Td

                                color="black" fontWeight="500"
                                py={4}
                              >
                                {item.header}
                              </Td>
                              <Td

                                color="black"
                                py={4}
                              >
                                {item.value}
                                {item.isApiKey && (
                                  <Text fontSize="xs" color="gray.500" mt={1}>
                                    This is your API Key
                                  </Text>
                                )}

                              </Td>
                              <Td color="black" py={4}>
                                {item.description}
                              </Td>
                            </Tr>
                          ))}
                        </Tbody>
                      </Table>
                    </TableContainer>

                    <Box mb="20px" >
                      <Text fontSize="20px" fontWeight="600" color="#000000" my="0px" >Select Template</Text>
                      <Divider my={2} />

                      <Card mb="10px" p={3} boxShadow={"0 1px 3px 0 #0000001a"} border={"1px solid #0000001a"}>
                        <Text fontSize="12px" mb="5px">Choose a template to test the API:</Text>
                        <Select
                          options={templateOptions}

                          onChange={(option) => handleSelectChange('template', option)}
                          placeholder="Select Template"
                          defaultValue={templateOptions.length > 0 ? templateOptions[0]?.value : null}

                        />

                      </Card>

                    </Box>
                    <Box >
                      <Text fontSize="20px" fontWeight="600" color="#000000" my="0px" >Request Payload</Text>
                      <Text fontSize="14px" fontWeight="400" color="#000000" my="0px" >
                        The request payload must be sent in JSON format, containing the recipient's number and the message text.
                      </Text>
                      <Divider my={2} />

                      <Card mb="10px" p={3} boxShadow={"0 1px 3px 0 #0000001a"} border={"1px solid #0000001a"}>
                        <pre style={{ backgroundColor: 'black', textShadow: 'none', color: 'white', padding: '0px', borderRadius: '8px' }}>
                          <span style={{ padding: 15, backgroundColor: '#2F2F2F', fontSize: '14px', display: 'block', marginBottom: '10px' }}>json</span>
                          <code
                            className="language-json"
                            style={{ padding: '0px 15px 15px', display: 'block', textWrap: "wrap" }}
                            dangerouslySetInnerHTML={{ __html: Prism.highlight(getFormattedJson(), Prism.languages.json, 'json') }}
                          />
                        </pre>
                      </Card>

                    </Box>



                    <Box mb="20px">
                      <div className="table_section">
                        <Box mb="10px">
                          <Text fontSize="20px" fontWeight="600" color="#000000" my="0px" >Payload Fields</Text>
                        </Box>
                        <Divider my={2} />
                        <TableContainer
                          width="100%"
                          bg="white"
                          borderRadius="lg"
                          border="1px solid"
                          borderColor="gray.200"
                          overflow="hidden"
                        >
                          <Table variant="simple" width="100%">
                            <Thead bg="#f7f7f7">
                              <Tr>
                                <Th
                                  fontSize="14px"
                                  fontWeight="600"
                                  color="black"
                                  textTransform="none"
                                  letterSpacing="normal"
                                  py={4}
                                >
                                  Field
                                </Th>
                                <Th
                                  fontSize="14px"
                                  fontWeight="600"
                                  color="black"
                                  textTransform="none"
                                  letterSpacing="normal"
                                  py={4}
                                >
                                  Type
                                </Th>
                                <Th
                                  fontSize="14px"
                                  fontWeight="600"
                                  color="black"
                                  textTransform="none"
                                  letterSpacing="normal"
                                  py={4}
                                >
                                  Required
                                </Th>
                                <Th
                                  fontSize="14px"
                                  fontWeight="600"
                                  color="black"
                                  textTransform="none"
                                  letterSpacing="normal"
                                  py={4}
                                >
                                  Description
                                </Th>
                              </Tr>
                            </Thead>

                            <Tbody fontSize="14px">
                              {payloadFields?.map((field, index) => (
                                <Tr key={index}>

                                  <Td
                                    whiteSpace="normal"
                                    wordBreak="break-word"
                                  >
                                    {field.field}
                                    <br />
                                    {field?.isTemplateVariable ? (
                                      <Badge colorScheme="purple">Template Variable</Badge>
                                    ) : ""}
                                  </Td>

                                  <Td
                                    whiteSpace="normal"
                                  // wordBreak="break-word"
                                  >
                                    {field.type}
                                  </Td>

                                  <Td
                                    whiteSpace="normal"
                                    wordBreak="break-word"
                                  >
                                    {field.required ? <Tag bg={"#dc2626"} color={"white"} fontSize={"xs"}>Yes</Tag> : <Tag bg={"white"} color={"black"} border={"1px solid #EDF2F7"} fontSize={"xs"}>No</Tag>}
                                  </Td>

                                  <Td
                                    whiteSpace="normal"
                                    wordBreak="break-word"
                                  >
                                    <Text>{field?.description}</Text>
                                  </Td>
                                </Tr>
                              ))}
                            </Tbody>
                          </Table>
                        </TableContainer>
                      </div>
                    </Box>
                    <Box mb="20px">
                      <div className="table_section">
                        <Box mb="5px">
                          <Text fontSize="20px" fontWeight="600" color="#000000" my="0px" >Preferred Channel</Text>
                        </Box>
                        <Text fontSize="14px" fontWeight="400" color="#000000" my="0px" >
                          Following are the Values for “preferred_channel” in Request Payload
                        </Text>
                        <Divider my={2} />
                        <TableContainer width="100%"
                          bg="white"
                          borderRadius="lg"
                          border="1px solid"
                          borderColor="gray.200"
                          overflow="hidden">
                          <Table variant='simple' width="100%">
                            <Thead bg="#f7f7f7">
                              <Tr>
                                <Th fontSize="14px"
                                  fontWeight="600"
                                  color="black"
                                  textTransform="none"
                                  letterSpacing="normal"
                                  py={4}>Channel</Th>
                                <Th fontSize="14px"
                                  fontWeight="600"
                                  color="black"
                                  textTransform="none"
                                  letterSpacing="normal"
                                  py={4}>Value</Th>
                                <Th fontSize="14px"
                                  fontWeight="600"
                                  color="black"
                                  textTransform="none"
                                  letterSpacing="normal"
                                  py={4}>Description</Th>
                              </Tr>
                            </Thead>

                            <Tbody fontSize="14px">
                              {Preferred_Channel.map((field, index) => (
                                <Tr key={index}>
                                  <Td>{field.channel}</Td>
                                  <Td>{field.value}</Td>
                                  {/* <Td>{field.description}</Td> */}
                                  <Td>
                                    <Text >{field?.description}</Text>
                                  </Td>
                                </Tr>
                              ))}
                            </Tbody>


                          </Table>

                        </TableContainer>
                      </div>
                    </Box>




                    <Box mb="20px">
                      <Text fontSize="20px" fontWeight="600" color="#000000" my="0px" >Response</Text>
                      <Text fontSize="14px" fontWeight="400" color="#000000" my="0px" >
                        If the message is successfully sent, you will receive a response like this:
                      </Text>
                      <Divider my={2} />
                      <Card mb="10px" p={3} boxShadow={"0 1px 3px 0 #0000001a"} border={"1px solid #0000001a"}>

                        <pre style={{ backgroundColor: 'black', textShadow: 'none', color: 'white', padding: '0px', borderRadius: '8px' }}>
                          <span style={{ padding: 15, backgroundColor: '#2F2F2F', fontSize: '14px', display: 'block', marginBottom: '10px' }}>json</span>
                          <code className="language-json" style={{ padding: '0px 15px 15px', display: 'block' }}>
                            {JSON.stringify(responsedata, null, 2)}
                          </code>
                        </pre>
                      </Card>
                    </Box>


                    <Box mb="20px">
                      <div className="table_section">
                        <Box mb="10px">
                          <Text fontSize="20px" fontWeight="600" color="#000000" my="0px" >API Response Code</Text>
                        </Box>
                        <Divider my={2} />
                        <TableContainer
                          width="100%"
                          bg="white"
                          borderRadius="lg"
                          border="1px solid"
                          borderColor="gray.200"
                          overflow="hidden"
                        >
                          <Table variant="simple" width="100%">
                            <Thead bg="#f7f7f7">
                              <Tr>
                                <Th fontSize="14px" fontWeight="600" color="black" textTransform="none" letterSpacing="normal" py={4}>
                                  Code
                                </Th>
                                <Th fontSize="14px" fontWeight="600" color="black" textTransform="none" letterSpacing="normal" py={4}>
                                  Status
                                </Th>
                                <Th fontSize="14px" fontWeight="600" color="black" textTransform="none" letterSpacing="normal" py={4}>
                                  Description
                                </Th>
                              </Tr>
                            </Thead>
                            <Tbody fontSize="14px">
                              {responseCodes.map((item, index) => (
                                <Tr key={index} _hover={{ bg: "gray.50" }}>
                                  <Td color="black" fontWeight="500" py={4} >
                                    {item.code}
                                  </Td>
                                  <Td py={4}>
                                    <Tag
                                      bg={item.color === 'green' ? '#22c55e' : item.color === 'red' ? '#dc2626' : '#f97316'}
                                      color="white"
                                      fontSize="xs"
                                    >
                                      {item.status}
                                    </Tag>
                                  </Td>
                                  <Td color="black" py={4} whiteSpace="normal" wordBreak="break-word">
                                    {item.description}
                                  </Td>
                                </Tr>
                              ))}
                            </Tbody>
                          </Table>
                        </TableContainer>
                      </div>
                    </Box>


                    <Box mb="20px">
                      <div className="table_section">
                        <Box mb="10px">
                          <Text fontSize="20px" fontWeight="600" color="#000000" my="0px" >Other Information</Text>
                        </Box>
                        <Divider my={2} />

                        <TableContainer width="100%"
                          bg="white"
                          borderRadius="lg"
                          border="1px solid"
                          borderColor="gray.200"
                          overflow="hidden">
                          <Table variant='simple' width="100%" >
                            <Thead bg="#f7f7f7">
                              <Tr>
                                <Th fontSize="14px"
                                  fontWeight="600"
                                  color="black"
                                  textTransform="none"
                                  letterSpacing="normal"
                                  py={4}>Key</Th>
                                <Th fontSize="14px"
                                  fontWeight="600"
                                  color="black"
                                  textTransform="none"
                                  letterSpacing="normal"
                                  py={4}>Description</Th>
                              </Tr>
                            </Thead>

                            <Tbody fontSize="14px">
                              <Tr>
                                <Td>message-id</Td>
                                <Td>An auto generated unique 36 alpha numeric string</Td>
                              </Tr>
                              <Tr>
                                <Td>accepttime</Td>
                                <Td>
                                  The time we received and accepted the message request
                                </Td>
                              </Tr>
                            </Tbody>


                          </Table>

                        </TableContainer>
                      </div>
                    </Box>


                    <Box mb="30px">
                      <Text
                        fontSize="16px"
                        fontWeight="600"
                        color="#000000"
                        mb="10px"

                      >
                        Notes
                      </Text>
                      <Divider my={2} />
                      <Box
                        bg="#eaf3fdeb"
                        borderRadius="lg"
                        p={4}
                        border="1px solid"
                        borderColor="var(--brand-tint-strong)"
                      >
                        <VStack align="stretch" spacing={3}>
                          {defaultNotes.map((note, index) => (
                            <HStack key={index} align="flex-start" spacing={3}>
                              <Box
                                w="8px"
                                h="8px"
                                bg="var(--brand-primary)"
                                borderRadius="50%"
                                mt="6px"
                                flexShrink={0}
                              />
                              <Text
                                fontSize="12px"
                                fontWeight="400"
                                color="#000000"
                                lineHeight="1.6"

                              >
                                {note}
                              </Text>
                            </HStack>
                          ))}
                        </VStack>
                      </Box>
                    </Box>

                  </TabPanel>

                  <TabPanel>

                    <Box my="20px" >
                      <HStack >
                        <Box>
                          <Tag borderRadius="md" fontSize="12px" fontWeight="600" bg="#ff6900" color="white" my="0px" >Post</Tag>
                        </Box>
                        <Tag bg={"#fefce8"} color={"#a65f00"} border={"1px solid #fff085"}>
                          <Link color="#a65f00" fontSize="16px" fontWeight="400" my="0px" href="#">{process.env.REACT_APP_SEND_API_URL}/v2/message</Link>
                        </Tag>
                      </HStack>



                    </Box>
                    <SMSOnlyAPIPanel list={{ api_key: apiKey }} />
                  </TabPanel>
                </TabPanels>
              </Tabs>
              <Divider my={2} />





            </Box>

          </Flex>
        </VStack> : <Box className='card-style'>
          <Center h="400px">
            <Box textAlign="center">
              <Text fontSize="xl" fontWeight="semibold" color="gray.700" mb={2}>
                No Access
              </Text>
              <Text fontSize="sm" color="gray.500">
                You don't have permission to view this sections.
              </Text>
            </Box>
          </Center>
        </Box>}

      </BoxWrapper>
    </>
  );
}

export default User;